import { useMutation, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { ICategoryGroup } from "../../models/CategoryGroup/CategoryGroup";
import { CategoryGroupQueryKeys } from "./keys";

interface ICreateCategoryGroupRequest {
  name: string;
}

interface IUpdateCategoryGroupCategoriesRequest {
  categoryIds: string[];
}

export default function useCategoryGroupMutations() {
  const { post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const create = useMutation({
    mutationFn: (req: ICreateCategoryGroupRequest) => post(`/part/category-groups`, req),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CategoryGroupQueryKeys.all() });
    },
  });

  const update = useMutation({
    mutationFn: (categoryGroup: ICategoryGroup) =>
      put(`/part/category-groups/${categoryGroup.id}`, { name: categoryGroup.name }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CategoryGroupQueryKeys.all() });
    },
  });

  const updateCategories = useMutation({
    mutationFn: (payload: { categoryGroupId: string; categoryIds: string[] }) =>
      put(`/part/category-groups/${payload.categoryGroupId}/categories`, {
        categoryIds: payload.categoryIds,
      } as IUpdateCategoryGroupCategoriesRequest),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CategoryGroupQueryKeys.all() });
    },
  });

  const remove = useMutation({
    mutationFn: (categoryGroupId: string) => del(`/part/category-groups/${categoryGroupId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CategoryGroupQueryKeys.all() });
    },
  });

  return {
    create,
    update,
    updateCategories,
    remove,
  };
}
